import { gql } from "@apollo/client";

export const QUERY_MATCH = gql`
  query matchDetails($id: ID!) {
    match(id: $id) {
      id
      location
      date
      time
      status
      homeTeam {
        name
        id
        squad {
          name
          surname
          id
        }
      }
      awayTeam
      isHomeTeamLocal
      score {
        home
        away
      }
      playersSelected {
        name
        id
      }
      playersConfirmed {
        name
        surname
        number
        id
        avatarUrl
        position
      }
      scorerList {
        player {
          id
          name
          surname
          avatarUrl
          position
          number
        }
        goals
      }
      ownGoals
      mvp {
        id
        name
        surname
        avatarUrl
        position
        number
      }
      matchSummary
      config {
        numPlayers
        gameParts
        timePerPart
        substitutions
      }
      lineUp {
        player
        position
      }
    }
  }
`;

export const PUBLIC_MATCH_QUERY = gql`
  query publicMatch($id: ID!) {
    publicMatch(id: $id) {
      id
      date
      location
      homeTeam {
        name
      }
      awayTeam
      isHomeTeamLocal
      score {
        home
        away
      }
      scorerList {
        player {
          id
          name
          surname
          number
          position
          avatarUrl
        }
        goals
      }
      ownGoals
      config {
        numPlayers
        gameParts
        timePerPart
      }
      videos {
        id
        title
        description
        youtubeUrl
        youtubeVideoId
        fileUrl
        thumbnail
        duration
        uploadedAt
      }
    }
  }
`;

export const CREATE_MATCH_CALL = gql`
  mutation CreateMatchCall($matchId: ID!, $availablePlayers: [String]) {
    createMatchCall(matchId: $matchId, availablePlayers: $availablePlayers) {
      status
      playersConfirmed {
        name
        surname
        id
        number
      }
    }
  }
`;

export const START_MATCH = gql`
  mutation StartMatch($matchId: ID!) {
    startMatch(matchId: $matchId) {
      status
      score {
        home
        away
      }
    }
  }
`;

export const END_MATCH = gql`
  mutation EndMatch(
    $matchId: ID!
    $scoreHome: Int
    $scoreAway: Int
    $scorerList: [ScorerInput]
    $ownGoals: Int
    $admonisheds: [Admonished]
  ) {
    endMatch(
      input: {
        matchId: $matchId
        scoreHome: $scoreHome
        scoreAway: $scoreAway
        scorerList: $scorerList
        ownGoals: $ownGoals
        admonisheds: $admonisheds
      }
    ) {
      status
      score {
        home
        away
      }
    }
  }
`;
export const UPDATE_MATCH_EVENT = gql`
  mutation UpdateMatchEvent(
    $matchId: ID!
    $scoreHome: Int
    $scoreAway: Int
    $scorerList: [ScorerInput]
    $ownGoals: Int
    $admonisheds: [Admonished]
  ) {
    updateMatchEvent(
      input: {
        matchId: $matchId
        scoreHome: $scoreHome
        scoreAway: $scoreAway
        scorerList: $scorerList
        ownGoals: $ownGoals
        admonisheds: $admonisheds
      }
    ) {
      status
      score {
        home
        away
      }
    }
  }
`;

export const CONFIGURE_MATCH = gql`
  mutation ConfigureMatch(
    $matchId: ID!
    $numPlayers: Int!
    $gameParts: Int!
    $timePerPart: Int!
    $substitutions: Int!
  ) {
    configureMatch(
      input: {
        matchId: $matchId
        numPlayers: $numPlayers
        gameParts: $gameParts
        timePerPart: $timePerPart
        substitutions: $substitutions
      }
    ) {
      config {
        numPlayers
        gameParts
        timePerPart
        substitutions
      }
    }
  }
`;

export const SET_LINEUP = gql`
  mutation SetLineUp($matchId: ID!, $lineUp: [LineUpEntryInput]!) {
    setLineUp(matchId: $matchId, lineUp: $lineUp) {
      lineUp {
        player
        position
      }
    }
  }
`;

export const UPDATE_STATUS = gql`
  mutation UpdateStatus($matchId: ID!, $status: String!) {
    setStatus(matchId: $matchId, status: $status) {
      id
    }
  }
`;

export const UPDATE_MATCH_LOCATION = gql`
  mutation UpdateMatchLocation($matchId: ID!, $location: String!) {
    updateMatchLocation(matchId: $matchId, location: $location) {
      id
      location
    }
  }
`;

export const SET_MATCH_MVP = gql`
  mutation SetMatchMVP($matchId: ID!, $playerId: ID!) {
    setMatchMVP(matchId: $matchId, playerId: $playerId) {
      id
      mvp {
        id
        name
        surname
        avatarUrl
        position
        number
      }
    }
  }
`;

export const UPDATE_MATCH_SUMMARY = gql`
  mutation UpdateMatchSummary($matchId: ID!, $matchSummary: String!) {
    updateMatchSummary(matchId: $matchId, matchSummary: $matchSummary) {
      id
      matchSummary
      status
    }
  }
`;
